<template>
  <div>
    <!-- 卡片组件 -->
    <CardBox v-if="authjson.authjson(['4-1'])">
      <!-- <div slot="card_title" class="home_tit">{{$t("bank_card.FEB_Debit_Cards")}}</div> -->
    </CardBox>

    <!-- <div class="t_h1" v-if="authjson.authjson(['4-2'])">
      <div class="t_h1_top">{{$t('main.text322')}}</div>
      <div class="t_h1_box">
        <el-form class="zdy_form" label-position="top" :model="form">
          <el-form-item :label="$t('main.text622')">
            <el-input v-model="form.content" :placeholder="$t('main.text623')"></el-input>
          </el-form-item>

          <el-form-item :label="$t('main.text99')" class="riqi_box">
            <el-date-picker
              :editable="false"
              popper-class="time_box"
              :clearable="false"
              v-model="form.time"
              type="daterange"
              :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('main.text324')"
              :end-placeholder="$t('main.text325')">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('main.text316')">
            <el-select v-model="form.status" :placeholder="$t('main.text624')">
              <el-option :label="$t('main.text586')" value="1"></el-option>
              <el-option :label="$t('main.text587')" value="2"></el-option>
              <el-option :label="$t('main.text720')" value="7"></el-option>
              <el-option :label="$t('main.text585')" value="3"></el-option>
              <el-option :label="$t('main.text319')" value="4"></el-option>
              <el-option :label="$t('main.text588')" value="5"></el-option>
              <el-option :label="$t('main.text589')" value="6"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button class="reset_btn border_set_color" size="medium" @click="reset_btn">{{$t('main.text329')}}</el-button>
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{$t('main.text330')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div> -->

    <!-- <div class="transaction_h" v-if="authjson.authjson(['4-2'])">
      
      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">{{$t('main.text512')}}</div>
          </div>
          <div>
            <el-button v-if="authjson.authjson(['4-7'])" class="export_btn border_set_color2" size="medium" @click="refresh_btn">
              {{$t('main.text467')}}
            </el-button>

            <el-button v-if="authjson.authjson(['4-8'])" class="export_btn border_set_color2" size="medium" @click="go_list">
              <img class="btn_icon" src="../../assets/img/time_yellow_icon.png" alt="">
              {{$t('main.text580')}}
            </el-button>
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header cards_table">
          <el-table :data="tableData" stripe style="width: 100%"
          :row-class-name="row_bgc"
            >
            method: 提交方式 1网站内提交 2链接提交
            <el-table-column width="190" :label="$t('main.text99')">
              <span slot-scope="props">
                {{ overall_time(props.row.create_time) }}
              </span>
            </el-table-column>

            <el-table-column min-width="100" :label="$t('main.text567')">
              <span slot-scope="props">
                <div>{{ props.row.card_name }}</div>
              </span>
            </el-table-column>

            <el-table-column min-width="100" :label="$t('bank_card.Username')">
              <span slot-scope="props">
                <div>{{ props.row.username }}</div>
              </span>
            </el-table-column>

            <el-table-column min-width="150" :label="$t('main.text582')">
              <span slot-scope="props">
                <div v-if="props.row.number">{{ props.row.number }}</div>
                <div v-else> - </div>
              </span>
            </el-table-column>

            <el-table-column min-width="150" :label="$t('main.text592')">
              <span slot-scope="props">
                check_status: 前台审核状态 1待审核 2审核通过 3审核失败
                <div v-if="props.row.method==2">
                  <div v-if="props.row.check_status==1">
                    <div>{{$t('main.text318')}}</div>
                    <div>
                      <el-button @click="card_reason_ok_fun(props.row.id)" class="tab_btn1" icon="el-icon-check" size="mini">
                        {{$t('main.text583')}}
                      </el-button>
                    </div>
                    <div>
                      <el-button @click="card_reason_no_fun(props.row.id)" class="tab_btn2" icon="el-icon-close" size="mini">
                        {{$t('main.text584')}}
                      </el-button>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="props.row.check_status==2">{{$t('main.text571')}}</span>
                    <span v-else-if="props.row.check_status==3">{{$t('main.text572')}}</span>
                  </div>
                  
                </div>
                <div v-else>
                  <div>{{$t('main.text585')}}</div>
                </div>
              </span>
            </el-table-column>

            <el-table-column min-width="100">
              <template slot="header">
                {{$t('main.text581')}}
              </template>
              check_status: 前台审核状态 1待审核 2审核通过 3审核失败
              <span slot-scope="props">
                 <div v-if="props.row.method==2&&props.row.check_status!=2">-</div>
                 <div v-else>
                   status: 卡状态 0未提交 1 Pending, 2 processing, 3 approved ，4 rejected , 5 active , 6 blocked
                                        1Pending, 2processing, 3approved，4rejected, 5active , 6blocked 7kyc-approved
                  <span v-if="props.row.status==1">{{$t('main.text586')}}</span>
                  <span v-else-if="props.row.status==2">{{$t('main.text587')}}</span>
                  <span v-else-if="props.row.status==3">{{$t('main.text585')}}</span>
                  <span v-else-if="props.row.status==4" class="color_red">{{$t('main.text319')}}</span>
                  <span v-else-if="props.row.status==5">{{$t('main.text588')}}</span>
                  <span v-else-if="props.row.status==6" class="color_red">{{$t('main.text589')}}</span>
                  <span v-else-if="props.row.status==7">{{$t('main.text720')}}</span>
                  <span v-else>-</span>
                 </div>
              </span>
            </el-table-column>

            <el-table-column min-width="100" :label="$t('main.text593')">
              <span slot-scope="props">
                <div v-if="props.row.method==2&&props.row.check_status!=2">-</div>
                 <div v-else>
                  <div>{{ set_num3(props.row.balance) }}</div>
                 </div>
              </span>
            </el-table-column>

            <el-table-column min-width="190">
              <span slot-scope="props">
                status 状态 0未提交 1Pending, 2processing, 3approved，4rejected, 5active , 6blocked, 3显示激活，5显示充值
                卡状态  1Pending, 2processing, 3approved，4rejected, 5active , 6blocked 只有status 为5激活状态下可以修改密码
                <el-button v-if="props.row.status==3 " class="export_btn" size="medium" icon="el-icon-circle-check" @click="activate_btn(props.row.id)">{{$t('main.text625')}}</el-button>
                <div v-else-if="props.row.status==5 ">
                  <div>
                    <el-button v-if="authjson.authjson(['4-3'])" class="export_btn" size="medium" icon="el-icon-plus" @click="top_up_btn(props.row.id)">{{$t('main.text626')}}</el-button>
                  </div>
                  <div>
                    <el-button v-if="authjson.authjson(['4-4'])" class="export_btn" size="medium" @click="reset_pin_btn(props.row.id)" style="margin-top:5px;">{{$t('main.text705')}}</el-button>
                  </div>
                  <div>
                    <el-button v-if="authjson.authjson(['4-5'])" class="export_btn" size="medium" @click="transaction_list_btn(props.row.id)" style="margin-top:5px;">{{$t('main.text270')}}</el-button>
                  </div>
                </div>
                <span v-else> - </span>
              </span>
            </el-table-column>

            <el-table-column width="80">
              <span slot-scope="props">
                <img v-if="authjson.authjson(['4-6'])" @click="to_info(props.row.id)" class="icon_width" src="../../assets/img/info_icon.png" alt="">
              </span>
            </el-table-column>

          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="page_total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div> -->

    <!-- 通过 弹框 -->
    <el-dialog
      :visible.sync="card_reason_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text590") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text591") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="card_reason_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 拒绝 弹框 -->
    <el-dialog
      :title="$t('main.text594')"
      :visible.sync="card_reason_no_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="480px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{ $t("main.text595") }}</div>
            <el-form-item>
              <el-input
                type="textarea"
                v-model="card_reason"
                :placeholder="$t('main.text596')"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="card_reason_no_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="no_btn"
          class="confirm_btn confirm_btn_bgc"
        >
          {{ $t("main.text597") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活 填信息 弹框 -->
    <el-dialog
      :title="$t('main.text627')"
      :visible.sync="card_activate_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{ $t("main.text628") }}</div>
            <el-form-item :label="$t('main.text629')">
              <el-input v-model="card_digits"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text630')">
              <el-input v-model="card_id"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="card_activate_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="card_activate_submit"
          class="confirm_btn"
        >
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活成功 弹框 -->
    <el-dialog
      :visible.sync="card_activate_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text631") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text632") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="card_activate_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 第一次充值信息 弹框 -->
    <el-dialog
      :title="$t('main.text633')"
      :visible.sync="first_top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <!-- <div class="top_text2">{{$t('main.text634')}}</div> -->
            <!-- 年费，卡费，激活卡的费用 如果扣除过了就不需要展示了
            手续费是每次都会展示的
            最大最小充值也需要都展示吧 -->
            <!-- <div class="info_1" v-if="top_up_config.annual_fee_status==0 ">
              <div class="info_1_left">{{$t('main.text503')}}</div>
              <div class="info_1_right">{{top_up_config.annual_fee}}</div>
            </div>
            <div class="info_1" v-if="top_up_config.card_cost_status==0 ">
              <div class="info_1_left">{{$t('main.text504')}}</div>
              <div class="info_1_right">{{top_up_config.card_cost}}</div>
            </div> -->
            <!-- 激活卡的费用 -->
            <div
              class="info_1"
              v-if="top_up_config.card_activation_status == 0"
            >
              <div class="info_1_left">{{ $t("main.text644") }}</div>
              <div class="info_1_right">
                {{ top_up_config.card_activation }}
              </div>
            </div>
            <!-- 手续费 -->
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text645") }}</div>
              <div class="info_1_right">{{ top_up_config.load_fee }}</div>
            </div>
            <div class="info_1">
              <div class="info_1_left">{{ $t("main.text635") }}</div>
              <div class="info_1_right">{{ top_up_config.min_top_up }}</div>
            </div>
            <!-- <div class="info_1">
              <div class="info_1_left">{{$t('main.text636')}}</div>
              <div class="info_1_right">{{top_up_config.max_top_up}}</div>
            </div> -->
            <!-- 转换费 -->
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.text695") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDTUSD) }} -->
                {{ top_up_config.usdt_usd_rate }}
              </div>
            </div>
            <div class="info_1" v-if="top_up_config.top_up_fee_method == 1">
              <div class="info_1_left">{{ $t("main.text696") }}</div>
              <div class="info_1_right">
                <!-- {{ set_num_fee(rateConfig.USDCUSD) }} -->
                {{ top_up_config.usdc_usd_rate }}
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="first_top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button
          type="primary"
          @click="first_top_up_next"
          class="confirm_btn"
        >
          {{ $t("main.text394") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值 弹框 -->
    <el-dialog
      :title="$t('main.text626')"
      :visible.sync="top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text2">{{ $t("main.text637") }}</div>
            <div class="top_text3">{{ $t("main.text638") }}</div>
            <div class="amount_box">
              <div class="top_text4">{{ $t("main.text389") }}</div>
              <div class="top_text5">
                {{ $t("main.text650") }}{{ top_up_config.min_top_up }}
                <!-- {{$t('main.text651')}}{{top_up_config.max_top_up}} -->
              </div>
              <!-- <div class="zdy_input box_margin">
                <el-input v-model="input_v3_set"
                  placeholder=""
                  @input="input3_set"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{8}).*$/, '$1$2.$3').replace(/^\./g, '')"
                  ></el-input>
                  <el-popover
                    width="170"
                    popper-class="bz_pop"
                    v-model="visible3"
                    trigger="click">
                    <div slot="reference" class="type_box">
                      <div class="type_box1">
                        <img :src="set_name_img(select3)" alt="">
                        <div class="type_box2">{{select3}}</div>
                      </div>
                      <div class="type_box3"><i class="el-icon-caret-bottom"></i></div>
                    </div>
                    <div class="bz_list">
                      加密货币 BTC ETH USDT-ERC20 USDT-TRC20 USDT-BSC20 USDC-ERC20 USDC-TRC20 USDC-BSC20
                      <div class="type_box1 bz_list1" v-for="(item,index) in currency_list3" :key="index" @click="select3_fun(item)">
                        <img :src="set_name_img(item)" alt="">
                        <div class="type_box2">{{item}}</div>
                      </div>
                    </div>
                  </el-popover>
              </div> -->

              <div class="zdy_input box_margin">
                <el-input
                  v-model="input_v3_set"
                  placeholder=""
                  @input="input3_set"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{8}).*$/, '$1$2.$3').replace(/^\./g, '')"
                ></el-input>
                <div class="top_text7_2">USD</div>
              </div>

              <!-- 充值数量超过充值限额 警示框 红色 -->
              <div class="warning_red" v-show="warning_red_show">
                <div class="warning_red_icon">
                  <i class="el-icon-warning"></i>
                </div>
                <div class="warning_red_text">
                  {{ $t("main.text653") }}{{ top_up_config.max_top_up
                  }}{{ $t("main.text654") }}
                </div>
              </div>
              <!-- 余额不足  警示框 黄色 -->
              <div
                class="warning_red warning_yellow"
                v-show="warning_yellow_show"
              >
                <div class="warning_red_icon warning_yellow_icon">
                  <i class="el-icon-warning"></i>
                </div>
                <div class="warning_red_text warning_yellow_text">
                  {{ $t("main.text655") }}
                  {{ select3 }}
                  {{ $t("main.text655_2") }}
                  <div>
                    <router-link
                      :to="{ path: '/blockchain_d/deposit' }"
                      class="top_up_link"
                      >{{ $t("main.text656") }}</router-link
                    >
                  </div>
                </div>
              </div>

              <div class="top_text4 top_text6">{{ $t("main.text741") }}</div>
              <!-- <div class="top_text7" v-show="usdt_num_show">USD {{usdt_num*1}}</div>result_num -->
              <div class="top_text7">
                <el-popover
                  width="170"
                  popper-class="bz_pop"
                  v-model="visible3"
                  trigger="click"
                >
                  <div slot="reference" class="type_box">
                    <div class="type_box1">
                      <img :src="set_name_img(select3)" alt="" />
                      <div class="type_box2">{{ select3 }}</div>
                    </div>
                    <div class="type_box3">
                      <i class="el-icon-caret-bottom"></i>
                    </div>
                  </div>
                  <div class="bz_list">
                    <div
                      class="type_box1 bz_list1"
                      v-for="(item, index) in currency_list3"
                      :key="index"
                      @click="select3_fun(item)"
                    >
                      <img :src="set_name_img(item)" alt="" />
                      <div class="type_box2">{{ item }}</div>
                    </div>
                  </div>
                </el-popover>
                <div class="div_num">{{ result_num * 1 }}</div>
              </div>

              <div class="top_text5 top_text5_2">
                {{ $t("main.text652") }}
                <span class="top_text10" v-if="select3 == 'BTC'"
                  >BTC = {{ top_up_details.btc_balance }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'ETH'"
                  >ETH = {{ top_up_details.eth_balance }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDT'"
                  >USDT = {{ top_up_details.usdt_balance }}</span
                >
                <span class="top_text10" v-else-if="select3 == 'USDC'"
                  >USDC = {{ top_up_details.usdc_balance }}</span
                >
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text742") }}{{ select3 }} = {{ amount_crypto }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text743") }}{{ select3 }} = {{ fee_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text744") }}{{ select3 }} =
                {{ total_crypto_amount }}
              </div>
              <div class="top_text5 top_text5_2">
                {{ $t("main.text745") }}= {{ afterBalance }}
              </div>
            </div>
            <div>
              <div class="top_text4 top_text6">{{ $t("main.text514") }}</div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text567") }}</div>
                <div class="top_text10">{{ top_up_details.card_name }}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">{{ $t("main.text658") }}</div>
                <div class="top_text10">{{ top_up_details.number }}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">
                  {{ $t("main.text255") }}
                  <!-- <br/>({{$t('main.text659')}} = {{top_up_details.card_limit}}) -->
                </div>
                <div class="top_text10">USD {{ top_up_details.balance }}</div>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="top_up_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="top_up_submit" class="confirm_btn">
          {{ $t("main.text36") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值成功 弹框 -->
    <el-dialog
      :visible.sync="top_up_success_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text639") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text640") }}
        {{ usdt_num }}
        {{ $t("main.text640_r") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="top_up_success_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 充值失败 弹框 -->
    <el-dialog
      :visible.sync="top_up_error_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img style="width: 35px" src="../../assets/img/error_icon.png" alt="" />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text641") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text642") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="reset_btn"
          @click="top_up_error_dlg = false"
          >{{ $t("main.text7") }}</el-button
        >
        <el-button type="primary" class="apply_btn" @click="card_topUp_fun">{{
          $t("main.text643")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 重置联名卡密码 弹框 -->
    <el-dialog
      :title="$t('main.text705')"
      :visible.sync="reset_pwd_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <el-form-item :label="$t('main.text706')">
              <el-input
                v-model="new_pin"
                :type="pwdType == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType = !pwdType">
                <img :src="pwdType ? pwd_yes : pwd_no" alt="" />
              </span>

              <div class="btm_text">{{ $t("main.text707") }}</div>
            </el-form-item>
            <el-form-item :label="$t('main.text708')">
              <el-input
                v-model="confirm_new_pin"
                :type="pwdType2 == true ? 'password' : 'text'"
                oninput="value=value.replace(/[^0-9]/g,'')"
                maxlength="4"
              ></el-input>
              <span class="show-pwd" @click="pwdType2 = !pwdType2">
                <img :src="pwdType2 ? pwd_yes : pwd_no" alt="" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="reset_pwd_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="reset_pwd_submit" class="confirm_btn">
          {{ $t("main.text130") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  card_record,
  card_audit,
  card_getTopUpConfig,
  card_active,
  card_topUp,
  refreshData,
  setPin,
  card_calc,
} from "@/api/api";
import CardBox from "../../component/card";
import BigNumber from "bignumber.js";
import { debounce } from "@/utils/util.js";

export default {
  components: {
    CardBox,
  },
  data() {
    return {
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      card_reason_ok_dlg: false,
      card_reason_no_dlg: false,
      card_reason: "",
      card_reason_no_id: "",

      form: {
        content: "",
        time: "",
        status: "",
      },
      card_activate_dlg: false,
      card_digits: "",
      card_id: "",
      card_activate_ok_dlg: false,
      first_top_up_dlg: false,
      top_up_dlg: false,

      visible3: false,
      select3: "USDT",
      input_v3: "",
      input_v3_set: "",
      inp3_ratio: "",

      // currency_list3:["BTC","ETH","USDT","USDC"],
      currency_list3: ["USDT", "USDC"],

      // 币种 图标
      icon_list: {
        ETH: require("../../assets/img/ETH.png"),
        USDT: require("../../assets/img/USDT.png"),
        BTC: require("../../assets/img/BTC.png"),
        USDC: require("../../assets/img/USDC.png"),
        USD: require("../../assets/img/USD.png"),
        CNY: require("../../assets/img/CNY.png"),
        SGD: require("../../assets/img/SGD.png"),
        GBP: require("../../assets/img/GBP.png"),
        AUD: require("../../assets/img/AUD.png"),
        HKD: require("../../assets/img/HKD.png"),
      },
      top_up_success_dlg: false,
      top_up_error_dlg: false,
      top_up_config: "",
      top_up_id: "",
      activate_card_id: "",
      top_up_details: "",
      rateConfig: "",
      usdt_num: "",
      usdt_num_show: false,
      account_num: "",
      warning_red_show: false,
      warning_yellow_show: false,
      result_num: "",

      reset_pwd_dlg: false,
      new_pin: "",
      confirm_new_pin: "",
      reset_pin_id: "",

      pwd_yes: require("../../assets/img/eye_no_b.png"),
      pwd_no: require("../../assets/img/eye_yes_b.png"),
      pwdType: true,
      pwdType2: true,
      amount_crypto: 0,
      fee_crypto_amount: 0,
      total_crypto_amount: 0,
      afterBalance: 0,
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", this.$t("main.text512"));
    // this.get_list();
  },
  methods: {
    set_num_fee(v) {
      let d = BigNumber(1).minus(v).times(100);
      return d + "%";
    },
    get_list() {
      card_record({
        page: this.page,
        limit: this.limit,
        start_date: this.form.time ? this.form.time[0] : "",
        end_date: this.form.time ? this.form.time[1] : "",
        content: this.form.content,
        status: this.form.status,
      }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data.list);
          this.page_total = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });
    },
    current_change(v) {
      this.page = v;
      this.limit = 10;
      this.get_list();
    },
    go_list() {
      this.$router.push("/top_up_history");
    },
    transaction_list_btn(id) {
      this.$router.push({ path: "/transaction_record", query: { id } });
    },
    row_bgc({ row }) {
      // console.log(row);
      // console.log(rowIndex);
      if (row.method == 2) {
        return "row_2_bgc";
      }
    },
    set_number_4(v) {
      if (v) {
        let str1 = str1.substr(-4);
        return "•••• •••• ••••" + str1;
      } else {
        return "-";
      }
    },
    to_info(id) {
      this.$router.push({ path: "/apply_card_info", query: { cards_id: id } });
    },
    // 通过
    card_reason_ok_fun(id) {
      card_audit({
        id: id,
        status: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.card_reason_ok_dlg = true;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    // 拒绝
    card_reason_no_fun(id) {
      this.card_reason_no_dlg = true;
      this.card_reason_no_id = id;
      // console.log(id);
    },
    // 拒绝 弹框 确定按钮
    no_btn() {
      if (!this.card_reason) {
        return this.message.ismessage("error", this.$t("main.text598"));
      }
      // id	Number	记录ID
      // status	Number	0拒绝 1通过
      // reason_ch	String	中文拒绝理由
      // reason_en	String	中文拒绝理由
      // reason_jp	String	中文拒绝理由
      let r_ch = "";
      let r_en = "";
      let r_jp = "";
      if (this.v_lan == "ch") {
        r_ch = this.card_reason;
        r_en = "";
        r_jp = "";
      } else if (this.v_lan == "jp") {
        r_ch = "";
        r_en = "";
        r_jp = this.card_reason;
      } else {
        r_ch = "";
        r_en = this.card_reason;
        r_jp = "";
      }

      card_audit({
        id: this.card_reason_no_id,
        status: 0,
        reason_ch: r_ch,
        reason_en: r_en,
        reason_jp: r_jp,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_reason_no_dlg = false;
          this.get_list();
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },

    reset_btn() {
      this.form.time = "";
      this.form.content = "";
      this.form.status = "";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      // console.log(this.form);
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    activate_btn(id) {
      this.card_digits = "";
      this.card_id = "";
      this.card_activate_dlg = true;
      this.activate_card_id = id;
      // console.log(this.activate_card_id);
    },
    card_activate_submit() {
      if (!this.card_digits.trim() || this.card_digits.length !== 16) {
        return this.message.ismessage("error", this.$t("main.text660"));
      }
      if (!this.card_id.trim()) {
        return this.message.ismessage("error", this.$t("main.text661"));
      }
      card_active({
        id: this.activate_card_id,
        number: this.card_digits,
        card_id: this.card_id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.card_activate_dlg = false;
          this.card_activate_ok_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    top_up_btn(id) {
      this.first_top_up_dlg = true;
      this.top_up_id = id;
      this.get_top_up_config(id);
    },
    first_top_up_next() {
      this.first_top_up_dlg = false;
      this.top_up_dlg = true;
      this.input_v3 = "";
      this.input_v3_set = "";
      this.usdt_num_show = false;
      this.warning_red_show = false;
      this.warning_yellow_show = false;
    },
    top_up_submit() {
      if (!this.input_v3.trim()) {
        return this.message.ismessage("error", this.$t("main.text389"));
      }
      // if (this.usdt_num <= this.account_num) {
      //   return this.message.ismessage('error',this.$t('main.text662'));
      // }

      if (this.input_v3 * 1 > this.top_up_config.max_top_up.substr(1) * 1) {
        return (this.warning_red_show = true);
      } else {
        this.warning_red_show = false;
      }

      // select3== BTC 'ETH' USDT USDC
      if (this.select3 == "BTC") {
        if (this.input_v3 * 1 > this.top_up_details.btc_balance) {
          return (this.warning_yellow_show = true);
        } else {
          this.warning_yellow_show = false;
        }
      } else if (this.select3 == "ETH") {
        if (this.input_v3 * 1 > this.top_up_details.eth_balance * 1) {
          return (this.warning_yellow_show = true);
        } else {
          this.warning_yellow_show = false;
        }
      } else if (this.select3 == "USDT") {
        if (this.input_v3 * 1 > this.top_up_details.usdt_balance * 1) {
          return (this.warning_yellow_show = true);
        } else {
          this.warning_yellow_show = false;
        }
      } else if (this.select3 == "USDC") {
        if (this.input_v3 * 1 > this.top_up_details.usdc_balance * 1) {
          return (this.warning_yellow_show = true);
        } else {
          this.warning_yellow_show = false;
        }
      }

      // if (this.usdt_num < (this.top_up_config.min_top_up).substr(1)*1) {
      //   return this.message.ismessage('error',this.$t('main.text663'));
      // }
      // if (this.usdt_num > (this.top_up_config.max_top_up).substr(1)*1) {
      //   return this.message.ismessage('error',this.$t('main.text664'));
      // }

      this.card_topUp_fun();
    },
    card_topUp_fun() {
      card_topUp({
        id: this.top_up_id,
        token_type: this.select3,
        amount: this.input_v3,
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage("success", res.data.msg);
          this.top_up_dlg = false;
          this.top_up_success_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
          this.top_up_error_dlg = true;
        }
      });
    },
    input3_set(v) {
      this.input_v3 = v;
      this.input_v3_set = this.set_num3_2(v);
      this.set_usd_num(v);
    },
    select3_fun(v) {
      this.select3 = v;
      this.visible3 = false;
      if (this.input_v3) {
        this.set_usd_num(this.input_v3);
      }
    },
    set_name_img(v) {
      if (v.indexOf("-") != -1) {
        let str1 = v.split("-")[0];
        return this.icon_list[str1];
      } else {
        return this.icon_list[v];
      }
    },
    // 设置key 对应接口 key
    set_api_key(v) {
      if (v.indexOf("-") != -1) {
        return v.toLowerCase().replace("-", "_");
      } else {
        return v.toLowerCase();
      }
    },
    get_top_up_config(id) {
      // 获取充值配置
      card_getTopUpConfig({ id: id * 1 }).then((res) => {
        if (res.data.code == 200) {
          this.top_up_config = res.data.data;
          this.top_up_details = res.data.details;
          this.rateConfig = res.data.details.rateConfig;
          // console.log(this.top_up_config);
          // console.log(this.top_up_details);

          this.result_num = "";
          this.select3 = "USDT";
          this.amount_crypto = 0;
          this.fee_crypto_amount = 0;
          this.total_crypto_amount = 0;
          this.afterBalance = 0;
        }
      });
    },
    // 计算 用户输入 转换usd
    set_usd_num(v) {
      if (v) {
        let _this = this;
        debounce(function () {
          card_calc({
            id: _this.top_up_id,
            token_type: _this.select3,
            amount: v,
          }).then((res) => {
            if (res.data.code == 200) {
              _this.result_num = res.data.data.total_crypto_amount;
              _this.amount_crypto = res.data.data.amount_crypto;
              _this.fee_crypto_amount = res.data.data.fee_crypto_amount;
              _this.total_crypto_amount = res.data.data.total_crypto_amount;
              _this.afterBalance = res.data.data.afterBalance;
            } else {
              _this.message.ismessage("error", res.data.msg);

              _this.result_num = 0;
              _this.amount_crypto = 0;
              _this.fee_crypto_amount = 0;
              _this.total_crypto_amount = 0;
              _this.afterBalance = 0;
            }
          });
        }, 1000);
      }
    },
    // 刷新
    refresh_btn() {
      refreshData().then((res) => {
        if (res.data.code == 200) {
          this.get_list();
          this.message.ismessage("success", this.$t("main.text673"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    reset_pin_btn(id) {
      this.reset_pin_id = id;
      this.new_pin = "";
      this.confirm_new_pin = "";
      this.reset_pwd_dlg = true;
    },
    reset_pwd_submit() {
      if (!this.new_pin)
        return this.message.ismessage("error", this.$t("main.text705"));
      if (!this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text706"));
      if (this.new_pin.length < 4 || this.confirm_new_pin.length < 4)
        return this.message.ismessage("error", this.$t("main.text707"));
      if (this.new_pin !== this.confirm_new_pin)
        return this.message.ismessage("error", this.$t("main.text209"));
      setPin({
        id: this.reset_pin_id,
        pin: this.new_pin,
        confirm_pin: this.confirm_new_pin,
      }).then((res) => {
        if (res.data.code == 200) {
          this.reset_pwd_dlg = false;
          this.get_list();
          this.message.ismessage("success", this.$t("main.text215"));
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  border-color: #deb981;
  background: transparent;
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-color: #deb981;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  /* min-width: 120px; */
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red {
  color: #f35f65;
}
.zdy_tab_header >>> .el-table tr th:last-child,
.zdy_tab_header >>> .el-table__body tr td:last-child {
  padding-left: 0 !important;
}
.btn_icon {
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1 {
  height: 32px;
  border: 1px solid #deb981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2 {
  height: 32px;
  border: 1px solid #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ff4646;
  background: transparent;
  margin-top: 10px;
}
.top_text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active {
  background: #f35f65;
  border-color: #f35f65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1 {
  display: flex;
  border-bottom: 1px solid #314b69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left {
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.info_1_right {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text3 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.amount_box {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223c58;
}
.top_text4 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 8px;
}
.top_text5 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text5_2:nth-child(8) {
  padding-top: 10px;
}
.top_text5_2 {
  padding-top: 2px;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner {
  /* width: 224px; */
  height: 68px;
  background: #223c58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input {
  width: 100%;
}
.zdy_input {
  display: flex;
}
.zdy_form >>> .el-form-item__label {
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box {
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #041728;
}
.type_box1 {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img {
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3 {
  color: rgba(255, 255, 255, 0.8);
}
.bz_list {
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1 {
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child {
  margin-bottom: 0;
}
.inp_btm_tit {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin {
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6 {
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7 {
  /* padding: 18px 12px 20px;
  background: #041728; */
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  display: flex;
  align-items: center;
}
.div_num {
  flex: 1;
  background: #223c58;
  text-align: right;
  height: 68px;
  line-height: 68px;
  box-sizing: border-box;
  padding-right: 15px;
  border-radius: 0 8px 8px 0;
}
.top_text7_2 {
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 0 8px 8px 0;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  min-width: 120px;
  text-align: center;
}
.top_text8 {
  display: flex;
  margin-top: 12px;
}
.top_text8 > div {
  width: 50%;
}
.top_text9 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
}
.top_text10 {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.warning_red {
  background: #fedfe0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow {
  background: #e8dac8;
}
.warning_red_icon i {
  color: #f35f65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #f35f65;
}
.warning_yellow_icon i,
.warning_yellow_text {
  color: #b28247;
}
.top_up_link {
  color: #041728;
  text-decoration: underline;
}
</style>

<style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell {
  background: #172c43 !important;
}
.cards_table .row_2_bgc:hover {
  background: #172c43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell {
  background: #172c43 !important;
}
/* ------ */
.bz_pop {
  color: #fff;
  font-size: 15px;
  background: #041e35;
  box-shadow: 0px 0px 4px #4f78a9;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
.btm_text {
  line-height: initial;
  padding-top: 5px;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 1px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
.show-pwd img {
  width: 18px;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
}
</style>
